import { string } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Card, Clickable, Icon, IconName, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { oaky } from '@mews-commander/assets';
import { TextKey } from '@mews-commander/enums';
import { MewsImage } from '@mews/business-components';
import { openInBrowserTab } from '@mews-commander/utils';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { MewsTeam } from '@mews/enums';

interface Props {
    reservationId: string;
}

const Upsell = ({ reservationId }: Props) => {
    const { data, isLoading } = useRepositoryQuery(
        'oaky',
        'getUrl',
        {
            reservationId,
        },
        {
            meta: {
                disableDefaultErrorHandler: true,
                logError: {
                    team: MewsTeam.Reservations,
                    logMessage: `Oaky URL failed to fetch for reservation: ${reservationId}`,
                },
            },
            retry: false,
        }
    );

    if (isLoading || data?.url == null) {
        return null;
    }

    const sanitazedUrl = pipe(
        data.url,
        // prettier-ignore
        // eslint-disable-next-line no-useless-escape
        string.replace('{\"url\":\"', ''),
        // prettier-ignore
        // eslint-disable-next-line no-useless-escape
        string.replace('\"}', ''),
        string.replace('\\/', '/'),
        string.replace('\\/', '/'),
        string.replace('\\/', '/')
    );

    return (
        <Stack distribution="stretch">
            <Clickable
                onClick={() => openInBrowserTab(sanitazedUrl)}
                data-test-upsell-button
                data-reservation-id={reservationId}
            >
                <Card padding="200">
                    <Stack itemAlignment="center" spacing="100" distribution="space-between">
                        <StackItem>
                            <MewsImage src={oaky} width="40px" />
                        </StackItem>
                        <StackItem grow>
                            <LocalizedText textKey={TextKey.ReservationUpsellAvailable} />
                        </StackItem>
                        <StackItem>
                            <Stack itemAlignment="center" spacing="100">
                                <Icon value={IconName.ExternalLink} size="small" />
                            </Stack>
                        </StackItem>
                    </Stack>
                </Card>
            </Clickable>
        </Stack>
    );
};

export default Upsell;
